import React from 'react';
import { Typography, Box, Divider } from '@mui/material';
import { FieldResultProps } from 'pages/Forms/FormResults/types/types';

export const SectionInput: React.FC<FieldResultProps> = ({
  item,
  tableType = false,
}) => (
  <>
    <Box padding={tableType ? 1 : 2}>
      {!tableType && (
        <Typography variant="h4">{item?.label || item?.name}</Typography>
      )}
      <Typography variant="body2">{item?.instruction ?? ''}</Typography>
    </Box>
    {!tableType && <Divider />}
  </>
);
